import { render, staticRenderFns } from "./Hispasec.vue?vue&type=template&id=1bce3438&"
import script from "./Hispasec.vue?vue&type=script&lang=js&"
export * from "./Hispasec.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports